var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view", attrs: { id: "booking-tree-grid" } },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "search-item",
            {
              ref: _vm.searchItemConfigModule,
              attrs: {
                "config-module": _vm.searchItemConfigModule,
                "is-collapse-list": !_vm.isFba,
                "grid-options": _vm.gridOptions,
                "grid-config-module": _vm.isFba ? "10012" : "150002",
                "is-append-query": true,
                reset: true,
                lob: "AE",
                "custom-search-items": _vm.customSearchItems,
                "custom-sim-query-placeholder": _vm.$t(
                  "Message.QuickSearchBusinessNo"
                ),
                "search-disabled": _vm.searchDisable,
                "record-expand-status": true,
                "input-enter-query": true
              },
              on: {
                "click-more": function(value) {
                  return (_vm.isAdvancedQuery = value)
                },
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemCallBack: _vm.toAdvancedQuery,
                perConfigChange: function(value) {
                  _vm.perConfigName = value
                },
                refreshGrid: function() {
                  _vm.gridRefreshId += 1
                },
                defaultSearchItemsChange: function(value) {
                  _vm.defaultSearchItems = value
                }
              }
            },
            [
              _c(
                "div",
                { attrs: { slot: "operations" }, slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "1",
                        disabled:
                          !_vm.selectedJob ||
                          _vm.total <= 0 ||
                          _vm.hqDisabledViewDetail ||
                          (!_vm.isHQ && !_vm.validSingleSelect) ||
                          _vm.hierarchyDisabledViewDetail,
                        type: "success"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toLook()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.look")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "2",
                        disabled:
                          !(
                            _vm.selectedJob &&
                            Number(_vm.selectedJob.jobState) === 0 &&
                            !_vm.JobUtils.isBlockJob(_vm.selectedJob)
                          ) ||
                          !_vm.validSingleSelect ||
                          !_vm.hierarchyValidSingleSelect,
                        type: "success"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toEdit()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.$checkPermission([
                              "button_AEBooking_addAEBooking"
                            ]) &&
                            !_vm.$checkPermission([
                              "button_Job_importOrderExcel"
                            ]),
                          expression:
                            "$checkPermission(['button_AEBooking_addAEBooking']) && !$checkPermission(['button_Job_importOrderExcel'])"
                        }
                      ],
                      staticStyle: { "margin-right": "5px" },
                      attrs: {
                        no: "3",
                        disabled: _vm.hqDisabledOperate,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toAdd()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.btn.new")) + " ")]
                  ),
                  _c(
                    "el-dropdown",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.$checkPermission([
                              "button_AEBooking_addAEBooking"
                            ]) &&
                            _vm.$checkPermission([
                              "button_Job_importOrderExcel"
                            ]),
                          expression:
                            "$checkPermission(['button_AEBooking_addAEBooking']) && $checkPermission(['button_Job_importOrderExcel'])"
                        }
                      ],
                      staticStyle: { margin: "0 5px" },
                      attrs: {
                        no: "exportOrderHandle",
                        "split-button": "",
                        type: "primary",
                        disabled: _vm.hqDisabledOperate
                      },
                      on: {
                        click: function($event) {
                          return _vm.exportOrderHandle()
                        },
                        command: function(p) {
                          _vm.exportOrderCommand = p
                          _vm.exportOrderHandle()
                        }
                      }
                    },
                    [
                      _vm.exportOrderCommand ===
                      _vm.$t("SeaExport.TemplateDownload")
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_DownImportTemplate")
                              )
                            )
                          ])
                        : _vm.exportOrderCommand !== _vm.$t("SeaExport.import")
                        ? _c("span", [_vm._v(_vm._s(_vm.exportOrderCommand))])
                        : _vm._e(),
                      _c(
                        "el-upload",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.exportOrderCommand ===
                                _vm.$t("SeaExport.import"),
                              expression:
                                "exportOrderCommand === $t('SeaExport.import')"
                            }
                          ],
                          staticStyle: {
                            display: "inline-block",
                            "margin-left": "5px"
                          },
                          attrs: {
                            action: _vm.actionOrderUrl,
                            headers: _vm.headers,
                            "show-file-list": false,
                            accept: ".xls, .xlsx",
                            "before-upload": _vm.beforeOrderUpload,
                            "on-success": _vm.uploadOrderSuccess,
                            "on-error": _vm.handleError,
                            data: {
                              branchId: _vm.$store.getters.currentOfficeId,
                              lob: "AE"
                            }
                          }
                        },
                        [
                          _c("span", { staticStyle: { color: "white" } }, [
                            _vm._v(_vm._s(_vm.$t("SeaExport.import")))
                          ])
                        ]
                      ),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: _vm.$t("SeaExport.Add") } },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("SeaExport.Add")) + " "
                              )
                            ]
                          ),
                          !_vm.isFba
                            ? _c(
                                "el-dropdown-item",
                                {
                                  attrs: { command: _vm.$t("SeaExport.import") }
                                },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      ref: "uploadOrder",
                                      staticStyle: { display: "inline-block" },
                                      attrs: {
                                        action: _vm.actionOrderUrl,
                                        headers: _vm.headers,
                                        "show-file-list": false,
                                        accept: ".xls, .xlsx",
                                        "before-upload": _vm.beforeOrderUpload,
                                        "on-success": _vm.uploadOrderSuccess,
                                        "on-error": _vm.handleError,
                                        data: {
                                          branchId:
                                            _vm.$store.getters.currentOfficeId,
                                          lob: "AE"
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "padding-left": "0px",
                                            color: "#6F6F6F",
                                            "text-align": "left",
                                            width: "80px"
                                          },
                                          attrs: {
                                            slot: "trigger",
                                            type: "text"
                                          },
                                          slot: "trigger"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("SeaExport.import"))
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isFba
                            ? _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "CargoMsg.Cargo_DownImportTemplate"
                                    )
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_DownImportTemplate"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.isFba &&
                          _vm.$checkPermission([
                            "button_FBAAeBooking_addAirFbaOrder"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t("FbaJob.batchImportOrder")
                                  }
                                },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      ref: "uploadBatchOrder",
                                      staticStyle: { display: "inline-block" },
                                      attrs: {
                                        action:
                                          _vm.URL.seaExport.batchImportFbaJob,
                                        headers: _vm.headers,
                                        "show-file-list": false,
                                        accept: ".xls, .xlsx",
                                        "before-upload": _vm.beforeOrderUpload,
                                        "on-success": _vm.uploadOrderSuccess,
                                        "on-error": _vm.handleError,
                                        data: {
                                          branchId:
                                            _vm.$store.getters.currentOfficeId,
                                          deptId:
                                            _vm.$store.getters.currentDeptId,
                                          lob: "FBA_AE"
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "padding-left": "0px",
                                            color: "#6F6F6F",
                                            "text-align": "left",
                                            width: "80px"
                                          },
                                          attrs: {
                                            slot: "trigger",
                                            type: "text"
                                          },
                                          slot: "trigger"
                                        },
                                        [
                                          _c("span", [
                                            _c("img", {
                                              attrs: {
                                                src: require("@/assets/fba-import.png")
                                              }
                                            })
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "FbaJob.batchImportOrder"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isFba &&
                          _vm.$checkPermission([
                            "button_FBAAeBooking_addAirFbaOrder"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "FbaJob.downloadBatchImportTemplate"
                                    )
                                  }
                                },
                                [
                                  _c("span", [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/fba-download.png")
                                      }
                                    })
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "FbaJob.downloadBatchImportTemplate"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.isFba &&
                          _vm.$checkPermission([
                            "button_FBAAeBooking_addAirFbaOrder"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t("FbaJob.importSingleOrder")
                                  }
                                },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      ref: "uploadSingleOrder",
                                      staticStyle: { display: "inline-block" },
                                      attrs: {
                                        action:
                                          _vm.URL.booking.airExport
                                            .fbaSingleImport,
                                        headers: _vm.headers,
                                        "show-file-list": false,
                                        accept: ".xls, .xlsx",
                                        "before-upload": _vm.beforeOrderUpload,
                                        "on-success":
                                          _vm.uploadSingleOrderSuccess,
                                        "on-error": _vm.handleError,
                                        data: {
                                          officeId:
                                            _vm.$store.getters.currentOfficeId,
                                          deptId:
                                            _vm.$store.getters.currentDeptId
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "padding-left": "0px",
                                            color: "#6F6F6F",
                                            "text-align": "left",
                                            width: "80px"
                                          },
                                          attrs: {
                                            slot: "trigger",
                                            type: "text"
                                          },
                                          slot: "trigger"
                                        },
                                        [
                                          _c("span", [
                                            _c("img", {
                                              attrs: {
                                                src: require("@/assets/fba-import.png")
                                              }
                                            })
                                          ]),
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("FbaJob.importSingleOrder")
                                            ) + " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isFba &&
                          _vm.$checkPermission([
                            "button_FBAAeBooking_addAirFbaOrder"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "FbaJob.downloadSingleImportTemplate"
                                    )
                                  }
                                },
                                [
                                  _c("span", [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/fba-download.png")
                                      }
                                    })
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "FbaJob.downloadSingleImportTemplate"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_AEBooking_addLCL"
                          ]),
                          expression:
                            "$checkPermission(['button_AEBooking_addLCL'])"
                        }
                      ],
                      attrs: {
                        no: "4",
                        type: "primary",
                        disabled: _vm.hqDisabledOperate
                      },
                      on: {
                        click: function($event) {
                          return _vm.toAdd({ masterFlag: true })
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.AddHbl")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission(["button_deleteAEJob"]),
                          expression: "$checkPermission(['button_deleteAEJob'])"
                        }
                      ],
                      attrs: {
                        no: "5",
                        type: "danger",
                        disabled: !_vm.validMultipleSelect
                      },
                      on: {
                        click: function($event) {
                          return _vm.toDelete()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "6",
                        type: "primary",
                        disabled: !_vm.validMultipleSelect
                      },
                      on: { click: _vm.batchUpdateSopStateHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.EditSopStatus")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_AEBooking_addAEBooking"
                          ]),
                          expression:
                            "$checkPermission(['button_AEBooking_addAEBooking'])"
                        }
                      ],
                      attrs: {
                        no: "7",
                        type: "primary",
                        disabled:
                          !_vm.validMultipleSelect ||
                          !_vm.hierarchyValidMultipleSelect
                      },
                      on: {
                        click: function($event) {
                          return _vm.toCopy()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Clone")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "8",
                        type: "success",
                        disabled: !_vm.validMultipleSelect
                      },
                      on: { click: _vm.printHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.PrintBooking")))]
                  ),
                  _c(
                    "el-dropdown",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_print_batchPrint"
                          ]),
                          expression:
                            "$checkPermission(['button_print_batchPrint'])"
                        }
                      ],
                      staticStyle: { margin: "0 5px" },
                      attrs: {
                        no: "9",
                        disabled:
                          !_vm.btnInfo.batchSelectFlag ||
                          !_vm.validMultipleSelect,
                        "split-button": "",
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          _vm.onBatchPrint(_vm.$t("SeaExport.BatchPrint"))
                        },
                        command: _vm.onBatchPrint
                      }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("SeaExport.BatchPrint")) + " "
                      ),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                command: _vm.$t(
                                  "queryJob.PrintByBusinessNumber"
                                )
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("queryJob.PrintByBusinessNumber"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "10",
                        type: "primary",
                        disabled: !_vm.validMultipleSelect
                      },
                      on: {
                        click: function($event) {
                          return _vm.toStatistics()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Statistics")))]
                  ),
                  _c(
                    "el-dropdown",
                    {
                      staticStyle: { margin: "0 5px", "font-size": "12px" },
                      attrs: { no: "11", disabled: !_vm.validMultipleSelect },
                      on: { command: _vm.batchHandle }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled:
                              !_vm.btnInfo.batchSelectFlag ||
                              !_vm.validMultipleSelect
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("SeaExport.BatchProcessing")) +
                              " "
                          ),
                          _c("i", {
                            staticClass: "el-icon-arrow-down el-icon--right"
                          })
                        ]
                      ),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _vm.$checkPermission([
                            "button_AEBooking_BatchShutOut"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 25 } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.BatchShutOut"))
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_JobBooking_BatchPerCommit"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 1 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.BatchPreSubmission")
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_JobBooking_BatchCommit"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 2 } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.BatchCommit"))
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_JobBooking_BatchManagerSubmission"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 3 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.BatchManagerSubmission")
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_JobBooking_ReturnToOperater"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 4 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SeaExport.BatchReturnPreSubmission"
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission(["button_JobBooking_Retract"])
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 5 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.BatchReturnSubmit")
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_Charge_BatchUnlockReceivable"
                                ]),
                                command: 12
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.BatchUnlockReceivableExpenses"
                                  )
                                ) + " "
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_Charge_BatchUnlockPayable"
                                ]),
                                command: 13
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SeaExport.BatchUnlockPayableFees")
                                ) + " "
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_Charge_BatchLockReceivable"
                                ]),
                                command: 6
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.BatchLockingReceivableExpenses"
                                  )
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_Charge_BatchLockPayable"
                                ]),
                                command: 7
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SeaExport.BatchLockingPayableFees")
                                )
                              )
                            ]
                          ),
                          _vm.$checkPermission([
                            "button_FBAAeBooking_fbaBatchUpdateDestinationMsg"
                          ]) && _vm.isFba
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 8 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "AirExport.BulkEditingDestinationPortInformation"
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_AEBooking_BatchUpdateCustomJobType"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    disabled: !_vm.$checkPermission([
                                      "button_AEBooking_BatchUpdateCustomJobType"
                                    ]),
                                    command: 9
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SeaExport.BatchUpdateCustomJobType"
                                      )
                                    ) + " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_AEBooking_BatchUpdateJobInfo"
                                ]),
                                command: 17
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.BatchModifyBusiness"))
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_jobSopTab_BatchReplaceTemplate"
                                ]),
                                command: 18
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.ReplaceSOPTemplatesInBatches"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm.useOrderCenterMode && !_vm.isRegionalCommission
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 19 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "queryJob.BatchInitiateCollaboration"
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.openMutualTrustConfig && !_vm.isFba
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 20 } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.BatchPushCharges"))
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_JobBooking_BatchFillGpExplain"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 21 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.BatchFillGpExplain")
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_JobBooking_BatchLockJob"
                                ]),
                                command: 22
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_BatchServiceLocking")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_JobBooking_BatchUnlockJob"
                                ]),
                                command: 23
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "CargoMsg.Cargo_UnlockServicesInBatches"
                                  )
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_JobBooking_BatchChangeBranch"
                                ]),
                                command: 24
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.BatchChangeCompany"))
                              )
                            ]
                          ),
                          _vm.$checkPermission([
                            "button_AEBooking_BatchPurchasePriceLock"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 26 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_BatchPurchasePriceLock"
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_AEBooking_BatchPurchasePriceUnLock"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 27 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_BatchPurchasePriceUnLock"
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_AEBooking_BatchSellingPriceUnLock"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 28 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_BatchSellingPriceUnLock"
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_AEBooking_BatchSellingPriceLock"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 29 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_BatchSellingPriceLock"
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission(["button_AEBooking_sendJdy"]) &&
                          _vm.sendToPlatform
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 30 } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.batchSendJdy"))
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_AEBooking_unlockJdy"
                          ]) && _vm.sendToPlatform
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 31 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SeaExport.batchUnlockGoodsDetails"
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_AEBooking_BatchExportToImport"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: "BatchExportToImport" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("queryJob.BatchExportToImport")
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_JobBooking_ReturnReview"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 32 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_BatchReturnPreApproval"
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._l(_vm.instructioinBtns, function(item, index) {
                            return [
                              _c(
                                "el-dropdown-item",
                                {
                                  key: "instruction" + index,
                                  attrs: {
                                    disabled: !item.allowOperate,
                                    command:
                                      "instruction," +
                                      item.tenantInstructionUuid
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$selectByLang(
                                          item.chineseName,
                                          item.englishName,
                                          item.japaneseName
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          })
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "tab_Charge_chargeView"
                          ]),
                          expression:
                            "$checkPermission(['tab_Charge_chargeView'])"
                        }
                      ],
                      staticClass: "el-dropdown-spacing",
                      attrs: {
                        no: "12",
                        "split-button": "",
                        type: "primary",
                        disabled: !_vm.validMultipleSelect
                      },
                      on: {
                        click: _vm.chargeHandle,
                        command: function(p) {
                          _vm.chargeCommand = p
                          _vm.chargeHandle()
                        }
                      }
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.chargeCommand) + " "),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: { command: _vm.$t("SeaExport.AddCharges") }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.AddCharges")))]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                command: _vm.$t("SeaExport.EditCharges")
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.EditCharges")))]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                command: _vm.$t("SeaExport.DeleteCharges")
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.DeleteCharges")))]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                command: _vm.$t("SeaExport.ChargeImport")
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.ChargeImport")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  !(
                    _vm.$checkPermission(["role_hideAllExports"]) &&
                    !_vm.$store.getters.isAdmin
                  )
                    ? _c(
                        "el-dropdown",
                        {
                          staticClass: "el-dropdown-spacing",
                          attrs: {
                            no: "13",
                            disabled: !_vm.validMultipleSelect,
                            "split-button": "",
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.exportHandle()
                            },
                            command: function(p) {
                              _vm.exportCommand = p
                              _vm.exportHandle()
                            }
                          }
                        },
                        [
                          _vm._v(" " + _vm._s(_vm.exportCommand) + " "),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t("SeaExport.ExportToExcel")
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.ExportToExcel"))
                                  )
                                ]
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "SeaExport.OverseasAgentEDI"
                                    )
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.OverseasAgentEDI"))
                                  )
                                ]
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "SeaExport.ExportWithSOPToExcel"
                                    )
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.ExportWithSOPToExcel")
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    disabled: !_vm.$checkPermission([
                                      "button_JobBooking_BatchExportCustoms"
                                    ]),
                                    command: _vm.$t(
                                      "CargoMsg.Cargo_ExportCustomsDeclaration"
                                    )
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_ExportCustomsDeclaration"
                                      )
                                    ) + " "
                                  )
                                ]
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    disabled: !_vm.$checkPermission([
                                      "button_JobBooking_BatchExport9610"
                                    ]),
                                    command: _vm.$t("SeaExport.Export9610File")
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.Export9610File")) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.$checkPermission(["button_AEBooking_importUnitLoadInfo"])
                    ? _c(
                        "el-dropdown",
                        {
                          staticClass: "el-dropdown-spacing",
                          attrs: { no: "14", disabled: _vm.hqDisabledOperate },
                          on: { command: _vm.unitLoadHandle }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                disabled: _vm.hqDisabledOperate
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("AirExport.ImportBoardInstallInfo")
                                  ) +
                                  " "
                              ),
                              _c("i", {
                                staticClass: "el-icon-arrow-down el-icon--right"
                              })
                            ]
                          ),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "AirExport.ImportBoardInstallInfo"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      ref: "uploadBoardInstallInfo",
                                      staticStyle: { display: "inline-block" },
                                      attrs: {
                                        action: _vm.importUnitLoadInfoUrl,
                                        headers: _vm.headers,
                                        "show-file-list": false,
                                        accept: ".xlsx",
                                        "before-upload": _vm.beforeUnitLoad,
                                        "on-success": _vm.uploadUnitLoadSuccess,
                                        "on-error": _vm.handleError,
                                        data: {
                                          branchId:
                                            _vm.$store.getters.currentOfficeId
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "padding-left": "0px",
                                            color: "#6F6F6F",
                                            "text-align": "left",
                                            width: "80px"
                                          },
                                          attrs: {
                                            slot: "trigger",
                                            type: "text"
                                          },
                                          on: { click: _vm.onImportBoardClick },
                                          slot: "trigger"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "AirExport.ImportBoardInstallInfo"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "SeaExport.TemplateDownload"
                                    )
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.TemplateDownload"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-dropdown",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.toExoSystemYGSH &&
                            _vm.$checkPermission(["button_Charge_ltsSync"]),
                          expression:
                            "toExoSystemYGSH && $checkPermission(['button_Charge_ltsSync'])"
                        }
                      ],
                      staticStyle: { margin: "0 5px", "font-size": "12px" },
                      attrs: { disabled: !_vm.validMultipleSelect },
                      on: { command: _vm.batchLtsSyncHandle }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: !_vm.btnInfo.batchSelectFlag
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "CargoMsg.Cargo_SynchronousCloudPlatform"
                                )
                              ) +
                              " "
                          ),
                          _c("i", {
                            staticClass: "el-icon-arrow-down el-icon--right"
                          })
                        ]
                      ),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c("el-dropdown-item", { attrs: { command: 1 } }, [
                            _vm._v(_vm._s(_vm.$t("SeaExport.receivable")))
                          ]),
                          _c("el-dropdown-item", { attrs: { command: 2 } }, [
                            _vm._v(_vm._s(_vm.$t("SeaExport.payable")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              !_vm.isFba
                ? _c("cargo-ag-grid-wrapper", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      "config-module": "150002",
                      "per-config-name": _vm.perConfigName,
                      "refresh-id": _vm.gridRefreshId,
                      "grid-options": _vm.gridOptions,
                      "side-bar": {
                        toolPanels: ["columns", "filter"],
                        visible: false
                      },
                      "column-defs": _vm.finalColumnDefs,
                      "sum-column-defs": _vm.sumColumnDefs,
                      "row-data": _vm.rowData,
                      "grid-params": _vm.gridParams,
                      "check-main-record": false,
                      "deselect-main-record": false,
                      "show-selected-color": false,
                      "show-row-groups": _vm.dataListDragGroup,
                      "darg-group-show-column-def": _vm.dargGroupShowColumnDef
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.gridParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.gridParams = $event
                      },
                      gridReady: _vm.onGridReady,
                      columnRowGroupChanged: function() {
                        this$1.$refs[
                          _vm.searchItemConfigModule
                        ].clickCollapseList()
                      }
                    }
                  })
                : _vm._e(),
              _vm.isFba
                ? _c("cargo-ag-grid", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      "config-module": "10012",
                      "per-config-name": _vm.perConfigName,
                      "refresh-id": _vm.gridRefreshId,
                      "grid-options": _vm.gridOptions,
                      "side-bar": {
                        toolPanels: ["columns", "filter"],
                        visible: false
                      },
                      "column-defs": _vm.fbaColumnDefs,
                      "row-data": _vm.rowData,
                      "grid-params": _vm.gridParams,
                      "check-main-record": false,
                      "deselect-main-record": false,
                      "show-selected-color": false
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.gridParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.gridParams = $event
                      },
                      gridReady: _vm.onGridReady
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.appendQuery,
                    expression: "!appendQuery"
                  }
                ],
                attrs: {
                  total: _vm.total,
                  "config-module": _vm.isFba ? "10012" : "150002",
                  "page-count": _vm.pageCount,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize,
                  "selected-row-count": _vm.isFba ? 0 : _vm.selectedRowCount
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: function() {
                    if (_vm.total > 0) {
                      _vm.toQueryByPage()
                    }
                  }
                }
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.appendQuery,
                      expression: "appendQuery"
                    }
                  ],
                  staticClass: "pagination-container"
                },
                [
                  _c("el-pagination", {
                    staticStyle: { "text-align": "left" },
                    attrs: { total: _vm.total, layout: "total" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.stateDialog.visible
        ? _c("state-dialog", {
            attrs: {
              visible: _vm.stateDialog.visible,
              rows: _vm.stateDialog.rows,
              "tracking-list": _vm.stateDialog.trackingList
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.stateDialog, "visible", $event)
              },
              callback: function($event) {
                return _vm.toQuery()
              }
            }
          })
        : _vm._e(),
      _vm.shutOutDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                no: "21",
                visible: _vm.shutOutDialog.visible,
                title: _vm.$t("Message.Warning"),
                width: "400px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.shutOutDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    "padding-left": "30px"
                  }
                },
                [
                  _c("span", { staticStyle: { "line-height": "40px" } }, [
                    _vm._v(_vm._s(_vm.$t("Message.PleaseConfirmTheShutOut")))
                  ]),
                  _c("span", { staticStyle: { "line-height": "18px" } }, [
                    _vm._v(_vm._s(_vm.shutOutDialog.shutOutTip1))
                  ]),
                  _c("span", { staticStyle: { "line-height": "18px" } }, [
                    _vm._v(_vm._s(_vm.shutOutDialog.shutOutTip2))
                  ])
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "22", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.hasChargeShutoutHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.HasChargeToShutOut")))]
                  ),
                  _c(
                    "el-button",
                    {
                      style: { display: _vm.shutOutDialog.shutOutButtonShow2 },
                      attrs: { no: "23", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.noHasChargeShutoutHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.NoChargeToShutOut")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "24" },
                      on: {
                        click: function($event) {
                          _vm.shutOutDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.transshipDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                no: "25",
                visible: _vm.transshipDialog.visible,
                title: _vm.$t("SeaExport.BatchVessel"),
                width: "360px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.transshipDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "85px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.vessel") } },
                    [
                      _c("cargo-advance-select", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.transshipDialog.isDBFlag,
                            expression: "!transshipDialog.isDBFlag"
                          }
                        ],
                        staticStyle: { width: "195px" },
                        attrs: {
                          no: "26",
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Vessel,
                          "default-value": _vm.transshipDialog.txtVessel,
                          "callback-params": { key: "txtVessel" }
                        },
                        on: { parentCallBack: _vm.onVesselSelectionChange }
                      }),
                      _c("el-input", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.transshipDialog.isDBFlag,
                            expression: "transshipDialog.isDBFlag"
                          }
                        ],
                        staticStyle: { width: "195px" },
                        attrs: { no: "27" },
                        model: {
                          value: _vm.transshipDialog.txtVessel_1,
                          callback: function($$v) {
                            _vm.$set(_vm.transshipDialog, "txtVessel_1", $$v)
                          },
                          expression: "transshipDialog.txtVessel_1"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.voyage") } },
                    [
                      _c(
                        "el-select",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.transshipDialog.isDBFlag,
                              expression: "!transshipDialog.isDBFlag"
                            }
                          ],
                          staticStyle: { width: "195px" },
                          attrs: { no: "28" },
                          model: {
                            value: _vm.transshipDialog.txtVoyage,
                            callback: function($$v) {
                              _vm.$set(_vm.transshipDialog, "txtVoyage", $$v)
                            },
                            expression: "transshipDialog.txtVoyage"
                          }
                        },
                        _vm._l(_vm.transshipDialog.voyages, function(item) {
                          return _c("el-option", {
                            key: item.voyageId,
                            attrs: {
                              label: item.voyageNo,
                              value: item.voyageNo
                            }
                          })
                        }),
                        1
                      ),
                      _c("el-input", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.transshipDialog.isDBFlag,
                            expression: "transshipDialog.isDBFlag"
                          }
                        ],
                        staticStyle: { width: "195px" },
                        attrs: { no: "29" },
                        model: {
                          value: _vm.transshipDialog.txtVoyage_1,
                          callback: function($$v) {
                            _vm.$set(_vm.transshipDialog, "txtVoyage_1", $$v)
                          },
                          expression: "transshipDialog.txtVoyage_1"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ShippingCompany") } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "195px" },
                        attrs: {
                          no: "30",
                          filterable: "",
                          "options-width": "200px;",
                          "method-params": { seaCmp: true },
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "default-value":
                            _vm.transshipDialog.txtCarrierId || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            return (_vm.transshipDialog.txtCarrierId = p.cmpIdx)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("queryJob.dateOfDeparture") } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "195px" },
                        attrs: {
                          no: "31",
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.transshipDialog.dfETD,
                          callback: function($$v) {
                            _vm.$set(_vm.transshipDialog, "dfETD", $$v)
                          },
                          expression: "transshipDialog.dfETD"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("queryJob.bookingAgent") } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "195px" },
                        attrs: {
                          no: "32",
                          filterable: "",
                          "options-width": "200px;",
                          "method-params": { bookingAgent: true },
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "default-value":
                            _vm.transshipDialog.txtBookingAgent || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            return (_vm.transshipDialog.txtBookingAgent =
                              p.cmpIdx)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "33", type: "primary" },
                      on: { click: _vm.transShipClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "34" },
                      on: {
                        click: function($event) {
                          _vm.transshipDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.fullSpellTypeDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                no: "35",
                visible: _vm.fullSpellTypeDialog.visible,
                title: _vm.$t("SeaExport.BatchUpdateType"),
                width: "400px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.fullSpellTypeDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "120px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: {
                        label: _vm.$t("queryJob.BatchOfWholeSplicingType")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "190px" },
                          attrs: { no: "36" },
                          model: {
                            value: _vm.fullSpellTypeDialog.containerLoadType,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.fullSpellTypeDialog,
                                "containerLoadType",
                                $$v
                              )
                            },
                            expression: "fullSpellTypeDialog.containerLoadType"
                          }
                        },
                        _vm._l(
                          _vm.fullSpellTypeDialog.containerLoadTypes,
                          function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.chineseName,
                                value: item.code
                              }
                            })
                          }
                        ),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "37", type: "primary" },
                      on: { click: _vm.fullSpellTypeClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "38" },
                      on: {
                        click: function($event) {
                          _vm.fullSpellTypeDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: _vm.context,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _vm.statisticsDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                no: "39",
                visible: _vm.statisticsDialog.visible,
                title: _vm.$t("SeaExport.Statistics"),
                width: _vm.$selectByLang("360px", "445px"),
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.statisticsDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-width": _vm.$selectByLang("85px", "170px"),
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.Slaves") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "40", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtSlaves,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txtSlaves", $$v)
                          },
                          expression: "statisticsDialog.txtSlaves"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.Master") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "41", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtMaster,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txtMaster", $$v)
                          },
                          expression: "statisticsDialog.txtMaster"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.TotalTickets") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "42", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtCount,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txtCount", $$v)
                          },
                          expression: "statisticsDialog.txtCount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: {
                        label: _vm.$t("SeaExport.CommissionedNumberOfPackages")
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "50", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtQuantityContract,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.statisticsDialog,
                              "txtQuantityContract",
                              $$v
                            )
                          },
                          expression: "statisticsDialog.txtQuantityContract"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: {
                        label: _vm.$t("SeaExport.CommissionedGrossWeight")
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "51", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtWeightContract,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.statisticsDialog,
                              "txtWeightContract",
                              $$v
                            )
                          },
                          expression: "statisticsDialog.txtWeightContract"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.CommissionedVolume") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "52", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtCubageContract,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.statisticsDialog,
                              "txtCubageContract",
                              $$v
                            )
                          },
                          expression: "statisticsDialog.txtCubageContract"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: {
                        label: _vm.$t("SeaExport.CommissionedChargedWeight")
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "53", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtChargeWeightContract,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.statisticsDialog,
                              "txtChargeWeightContract",
                              $$v
                            )
                          },
                          expression: "statisticsDialog.txtChargeWeightContract"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.ActualQuantity") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "43", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtQuantityActual,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.statisticsDialog,
                              "txtQuantityActual",
                              $$v
                            )
                          },
                          expression: "statisticsDialog.txtQuantityActual"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("CargoMsg.Cargo_ActualWeight") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "44", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtWeightActual,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.statisticsDialog,
                              "txtWeightActual",
                              $$v
                            )
                          },
                          expression: "statisticsDialog.txtWeightActual"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.ActualVolume") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "45", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtCubageActual,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.statisticsDialog,
                              "txtCubageActual",
                              $$v
                            )
                          },
                          expression: "statisticsDialog.txtCubageActual"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("queryJob.actualChargedWeight") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "46", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtChargeWeightActual,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.statisticsDialog,
                              "txtChargeWeightActual",
                              $$v
                            )
                          },
                          expression: "statisticsDialog.txtChargeWeightActual"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.CustomerCount") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "47", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtCustomerCount,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.statisticsDialog,
                              "txtCustomerCount",
                              $$v
                            )
                          },
                          expression: "statisticsDialog.txtCustomerCount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.SpecifyAgentNumber") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "48", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtdesignationAgentNum,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.statisticsDialog,
                              "txtdesignationAgentNum",
                              $$v
                            )
                          },
                          expression: "statisticsDialog.txtdesignationAgentNum"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "custom", attrs: { "label-width": "0" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function($event) {
                              return _vm.handleStatistics(true)
                            }
                          },
                          model: {
                            value: _vm.statisticsDialog.containShutOutJob,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.statisticsDialog,
                                "containShutOutJob",
                                $$v
                              )
                            },
                            expression: "statisticsDialog.containShutOutJob"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.ContainShutOutJob")))]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "49" },
                      on: {
                        click: function($event) {
                          _vm.statisticsDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.Close")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.addChargeDetailDialog.visible
        ? _c("add-charge-detail-dialog", {
            attrs: {
              visible: _vm.addChargeDetailDialog.visible,
              "selected-jobs": _vm.addChargeDetailDialog.selectedJobs,
              "charge-type": _vm.addChargeDetailDialog.type,
              lob: _vm.isFba ? "FBA_AE" : "AE",
              location: _vm.location,
              "selected-scheme": _vm.addChargeDetailDialog.selectedScheme
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.addChargeDetailDialog, "visible", $event)
              },
              toChangeSchema: _vm.toChangeSchema
            }
          })
        : _vm._e(),
      _vm.editChargeDetailDialog.visible
        ? _c("edit-charge-detail-dialog", {
            attrs: {
              visible: _vm.editChargeDetailDialog.visible,
              "selected-jobs": _vm.editChargeDetailDialog.selectedJobs,
              "charge-type": _vm.editChargeDetailDialog.chargeType,
              lob: _vm.isFba ? "FBA_AE" : "AE"
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.editChargeDetailDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.deleteChargeDetailDialog.visible
        ? _c("delete-charge-detail-dialog", {
            attrs: {
              visible: _vm.deleteChargeDetailDialog.visible,
              "selected-jobs": _vm.deleteChargeDetailDialog.selectedJobs,
              "charge-type": _vm.deleteChargeDetailDialog.chargeType,
              lob: _vm.isFba ? "FBA_SE" : "SE"
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.deleteChargeDetailDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.chargeSchemeBatchDialog.visible
        ? _c("charge-scheme-batch-dialog", {
            attrs: {
              visible: _vm.chargeSchemeBatchDialog.visible,
              "selected-jobs": _vm.chargeSchemeBatchDialog.selectedJobs,
              job: _vm.chargeSchemeBatchDialog.job,
              "need-check-range": _vm.chargeSchemeBatchDialog.needCheckRange,
              lob: _vm.chargeSchemeBatchDialog.lob,
              "is-sea": _vm.chargeSchemeBatchDialog.isSea,
              "original-condition":
                _vm.chargeSchemeBatchDialog.originalCondition,
              "charge-scheme-is-approved":
                _vm.chargeSchemeBatchDialog.chargeSchemeIsApproved,
              location: _vm.location,
              "charge-type": _vm.chargeSchemeBatchDialog.chargeType,
              source: _vm.chargeSchemeBatchDialog.source
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.chargeSchemeBatchDialog, "visible", $event)
              },
              selectedSchemeHandler: _vm.handleSelectedScheme
            }
          })
        : _vm._e(),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            ref: "batchCheckingWindow",
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              "allow-partial-check-pass":
                _vm.batchCheckingWindow.allowPartialCheckPass,
              lob: _vm.lob,
              jobs: _vm.batchCheckingWindow.jobs,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack,
              "call-back2": _vm.batchCheckingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.checkingWindow.visible
        ? _c("checking-window", {
            attrs: {
              visible: _vm.checkingWindow.visible,
              lob: _vm.lob,
              job: _vm.job,
              "check-node": _vm.checkingWindow.checkNode,
              "call-back": _vm.checkingWindow.callBack,
              "call-back2": _vm.checkingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("booking-print-window", {
        attrs: {
          jobs: _vm.bookingPrintWindow.jobs,
          visible: _vm.bookingPrintWindow.visible
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.bookingPrintWindow, "visible", $event)
          },
          print: _vm.sendSiteOpPrint,
          sendSiteOpCallBack: _vm.sendSiteOpCallBack
        }
      }),
      _vm.podInfo.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.podInfo.visible,
                title: _vm.$t(
                  "AirExport.BulkEditingDestinationPortInformation"
                ),
                width: "700px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.podInfo, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", flex: "1" } },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { "padding-right": "20px" },
                      attrs: {
                        "label-width": "120px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "AirExport.OverseasWarehouseNonAmazonWarehouse"
                                    ),
                                    label: _vm.$t(
                                      "SeaExport.EstimatedDeliveryToWarehouseTime"
                                    )
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "45",
                                      type: "datetime",
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                      format: "yyyy-MM-dd HH:mm"
                                    },
                                    model: {
                                      value:
                                        _vm.podInfo
                                          .estimatedDeliveryToWarehouseTime,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.podInfo,
                                          "estimatedDeliveryToWarehouseTime",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "podInfo.estimatedDeliveryToWarehouseTime"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "AirExport.OverseasWarehouseNonAmazonWarehouse"
                                    ),
                                    label: _vm.$t(
                                      "SeaExport.ActualDeliveryToWarehouseTime"
                                    )
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "46",
                                      type: "datetime",
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                      format: "yyyy-MM-dd HH:mm"
                                    },
                                    model: {
                                      value: _vm.podInfo.deliveryTime,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.podInfo,
                                          "deliveryTime",
                                          $$v
                                        )
                                      },
                                      expression: "podInfo.deliveryTime"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.EstimatedDeliveryToCustomersWarehouseTime"
                                    )
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "47",
                                      type: "datetime",
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                      format: "yyyy-MM-dd HH:mm"
                                    },
                                    model: {
                                      value: _vm.podInfo.destPortDeliveryTime,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.podInfo,
                                          "destPortDeliveryTime",
                                          $$v
                                        )
                                      },
                                      expression: "podInfo.destPortDeliveryTime"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.ActualDeliveryToCustomersWarehouseTime"
                                    )
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "48",
                                      type: "datetime",
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                      format: "yyyy-MM-dd HH:mm"
                                    },
                                    model: {
                                      value: _vm.podInfo.deliveryCompletionDate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.podInfo,
                                          "deliveryCompletionDate",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "podInfo.deliveryCompletionDate"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "AirExport.EstimatedDeliveryTime"
                                    )
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "49",
                                      type: "datetime",
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                      format: "yyyy-MM-dd HH:mm"
                                    },
                                    model: {
                                      value: _vm.podInfo.estDeliveryTime,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.podInfo,
                                          "estDeliveryTime",
                                          $$v
                                        )
                                      },
                                      expression: "podInfo.estDeliveryTime"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "AirExport.ActualDeliveryTime"
                                    )
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "50",
                                      type: "datetime",
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                      format: "yyyy-MM-dd HH:mm"
                                    },
                                    model: {
                                      value: _vm.podInfo.actDeliveryTime,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.podInfo,
                                          "actDeliveryTime",
                                          $$v
                                        )
                                      },
                                      expression: "podInfo.actDeliveryTime"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.confirmBatchModifyPodInfo()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.podInfo.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _c("lts-batch-sync", {
        ref: "ltsBatchSyncCharge",
        attrs: { visible: _vm.ltsWindow.visible, keys: _vm.ltsWindow.keys },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.ltsWindow, "visible", $event)
          }
        }
      }),
      _c("batch-submit-or-approve-dialog", {
        attrs: {
          visible: _vm.batchSubmitOrApproveDialog.visible,
          "row-data": _vm.batchSubmitOrApproveDialog.rowData,
          "is-submit": true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.batchSubmitOrApproveDialog, "visible", $event)
          }
        }
      }),
      _c("batch-modify-business-dialog", {
        attrs: {
          visible: _vm.batchModifyBusinessDialog.visible,
          "job-keys": _vm.batchModifyBusinessDialog.jobKeys,
          "job-list": _vm.batchModifyBusinessDialog.jobList,
          lob: _vm.batchModifyBusinessDialog.lob
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.batchModifyBusinessDialog, "visible", $event)
          },
          callback: _vm.batchModifyBusinessCallback
        }
      }),
      _c("change-sop-template-dialog", {
        attrs: {
          visible: _vm.changeSopTemplateDialog.visible,
          lob: _vm.lob,
          "job-list": _vm.changeSopTemplateDialog.jobList
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.changeSopTemplateDialog, "visible", $event)
          },
          reload: _vm.reload
        }
      }),
      _c("batch-cooperation-dialog", {
        attrs: {
          visible: _vm.batchCooperationDialog.visible,
          "job-list": _vm.batchCooperationDialog.jobList,
          "order-center-branch": _vm.orderCenterBranch
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.batchCooperationDialog, "visible", $event)
          }
        }
      }),
      _c("download-import-template-dialog", {
        attrs: {
          visible: _vm.downloadImportTemplateDialog.visible,
          lob: _vm.downloadImportTemplateDialog.lob
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.downloadImportTemplateDialog, "visible", $event)
          }
        }
      }),
      _vm.workFlowApplyDialog.visible
        ? _c("job-work-flow-apply-dialog", {
            attrs: {
              visible: _vm.workFlowApplyDialog.visible,
              title: _vm.$t("CargoMsg.Cargo_Approving"),
              "process-info": _vm.workFlowApplyDialog.documentProcess,
              records: _vm.workFlowApplyDialog.approvalCommentsRecords,
              type: "approve",
              "doc-id": _vm.workFlowApplyDialog.documentProcess.docId,
              "document-config-id":
                _vm.workFlowApplyDialog.documentProcess.documentConfigId
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.workFlowApplyDialog, "visible", $event)
              },
              close: function($event) {
                _vm.workFlowApplyDialog.visible = false
              },
              closeAndRefresh: function() {
                _vm.workFlowApplyDialog.visible = false
                _vm.toQueryByPage()
              }
            }
          })
        : _vm._e(),
      _vm.unitLoadResult.visible
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.$t("Message.Prompt"),
                visible: _vm.unitLoadResult.visible,
                "close-on-click-modal": false,
                width: "460px"
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.unitLoadResult, "visible", $event)
                }
              }
            },
            [
              _vm.unitLoadResult.isSuccess
                ? _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" }
                    },
                    [
                      _c("img", {
                        staticStyle: {
                          width: "25px",
                          height: "25px",
                          margin: "0 10px"
                        },
                        attrs: { src: _vm.trueIcon }
                      }),
                      _c("div", { staticStyle: { "margin-left": "5px" } }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "16px",
                              "margin-bottom": "10px"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_ImportingData"))
                            )
                          ]
                        ),
                        _c("div", { staticStyle: { color: "red" } }, [
                          _vm._v(_vm._s(_vm.$t("AirExport.AsyncUploadLogView")))
                        ])
                      ])
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" }
                    },
                    [
                      _c("img", {
                        staticStyle: {
                          width: "25px",
                          height: "25px",
                          margin: "0 10px"
                        },
                        attrs: { src: _vm.falseIcon }
                      }),
                      _c("p", { staticStyle: { "margin-left": "5px" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("AirExport.PleaseImportCorrectTemplate")
                          ) + "（"
                        ),
                        _c(
                          "a",
                          {
                            staticStyle: { color: "blue" },
                            attrs: { href: "#" },
                            on: { click: _vm.downloadImportContainerTemplate }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("AirExport.ClickDownloadTemplate"))
                            )
                          ]
                        ),
                        _vm._v("）")
                      ])
                    ]
                  ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.unitLoadResult.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.Confirm2")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.gpExplain.visible
        ? _c("add-gp-explain-dialog", {
            attrs: {
              type: _vm.gpExplain.type,
              visible: _vm.gpExplain.visible,
              "job-uuids": _vm.gpExplain.jobUuids
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.gpExplain, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.modifyBranchDialog.visible
        ? _c("batch-modify-branch-dialog", {
            attrs: {
              visible: _vm.modifyBranchDialog.visible,
              "job-keys": _vm.modifyBranchDialog.jobKeys
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.modifyBranchDialog, "visible", $event)
              },
              reload: _vm.reload
            }
          })
        : _vm._e(),
      _vm.customJobTypeDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.customJobTypeDialog.visible,
                title: _vm.$t("SeaExport.BatchUpdateCustomJobType"),
                width: "400px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.customJobTypeDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "120px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.CustomJobType") + ":" }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          "select-type":
                            _vm.selectTypeNames.basic_data_CutomJobType,
                          filterable: "",
                          "method-params": {
                            type: _vm.SystemConstants.AE.code,
                            fba: _vm.isFba,
                            active: true
                          },
                          "default-value": _vm.customJobTypeDialog.customJobType
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.customJobTypeDialog.customJobType = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.customJobTypeClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.customJobTypeDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.chargeTypeDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_AddCostType"),
            width: "400px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.chargeTypeDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { margin: "30px 30px" } },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.chargeTypeDialog.type,
                    callback: function($$v) {
                      _vm.$set(_vm.chargeTypeDialog, "type", $$v)
                    },
                    expression: "chargeTypeDialog.type"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Receivable")))
                  ]),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Dues")))
                  ]),
                  _c("el-radio", { attrs: { label: 0 } }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ARAP")))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onChargeTypeDialogConfirm }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.chargeTypeDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c("job-return-review-dialog", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.returnReviewDialog.visible,
            expression: "returnReviewDialog.visible"
          }
        ],
        attrs: {
          visible: _vm.returnReviewDialog.visible,
          lob: "AE",
          "selected-jobs": _vm.returnReviewDialog.selectedJobs,
          srouce: "list"
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.returnReviewDialog, "visible", $event)
          },
          confirm: _vm.toQuery
        }
      }),
      _c("batch-export-to-import-window", { ref: "batchExportToImportWindow" }),
      _c("tenant-entrust-window", {
        ref: "tenantEntrustWindow",
        on: { instructionCallback: _vm.onInstructionCallback }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }